import { render, staticRenderFns } from "./channelPlatform.vue?vue&type=template&id=76a4c45e&scoped=true"
import script from "./channelPlatform.vue?vue&type=script&lang=js"
export * from "./channelPlatform.vue?vue&type=script&lang=js"
import style0 from "./channelPlatform.vue?vue&type=style&index=0&id=76a4c45e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a4c45e",
  null
  
)

export default component.exports